import { jsx as _jsx } from "preact/jsx-runtime";
import SitewideLogo from 'pathfinder/modules/SponsoredWidgetsSponsoredSitewideLogoConsumptionModule/components/Logo';
import { useIsUrlExternal } from 'pathfinder/modules/shared/hooks/useIsUrlExternal';
import { variantToImage } from 'pathfinder/modules/SponsoredWidgetsSponsoredSitewideLogoConsumptionModule/helpers/variantToImage';
export default function SponsoredWidgetsSponsoredSitewideLogoConsumptionModule({ sponsoredSitewideLogoId, images, clickThroughUrl, track, config: { variant }, }) {
    const isClickThroughUrlExternal = useIsUrlExternal(clickThroughUrl);
    const imageUrl = variantToImage(variant, images).url;
    return (_jsx(SitewideLogo, { imageUrl: imageUrl, url: clickThroughUrl, isUrlExternal: isClickThroughUrlExternal, track: track, logoid: sponsoredSitewideLogoId, variant: variant }, void 0));
}
